'use client'

import { Typo3Button } from '@/types/typo3'
import { Button } from '@/ui/components'
import { memo } from 'react'
import { ButtonProps as OriginalButtonProps } from '../types'

type ButtonProps = Omit<OriginalButtonProps, 'ref'> & {
  ref?: React.RefObject<HTMLElement>
}

interface Props extends ButtonProps {
  data: Typo3Button
}

const allowedVariants: ButtonProps['variant'][] = [
  'primary',
  'secondary',
  'ghost',
  'tertiary',
  'text',
  'shop',
  undefined
]

const ButtonTypo3 = ({ data, ...props }: Props) => {
  if (!data) {
    return null
  }

  const variant: ButtonProps['variant'] =
    data.variant === 'fill'
      ? 'primary'
      : allowedVariants.includes(data.variant as ButtonProps['variant'])
        ? (data.variant as ButtonProps['variant'])
        : undefined

  const { icon, iconPosition } = data

  return (
    <Button
      {...props}
      variant={variant}
      icon={icon}
      mode={data?.mode}
      iconPosition={iconPosition}
      href={data?.link}
      type={data?.type}
      aria-label={data.label || 'button'}
    >
      {data.label}
    </Button>
  )
}

export default memo(ButtonTypo3)
